import React from "react"
import { Link } from "gatsby"
import {
  PadlockIcon,
  PrinterIcon,
} from "components/page-components/Icons/small"
import { PaywallIllustrationDesk } from "components/noticepage_components"
import { PlacesOfDeliveryList } from "components/page-components/Ausschreibungsdienste/landingpage-components"

import {
  NoticepagePaywallHalfpage,
  NoticepagePaywallSticker,
} from "./upselling-components"

export const NoticeOverview = ({
  ActBefore,
  CompletitionDeadline,
  RefIDStringBI,
  ScopeOfServices,
  ServiceTypeName,
  TenderTypeName,
  ValidUntil,
  ZoneOfRequest,
  ZoneOfRequestName,
  already_expired,
  awarding_authority_address = {},
  bi_platform,
  buyer_string,
  content_html_preview,
  display_date,
  has_parts,
  is_direct_invite,
  is_magic_word_invite,
  is_preproduction_preview,
  linked_landingpages,
  mitteilungen_click,
  open_accept_invite_modal,
  paywall_preview_type,
  picked_part,
  places_of_delivery_struct,
  show_video,
  teilnahme_click,
  toggle_register_app_modal,
  unterlagen_click,
}) => {
  const has_table =
    is_direct_invite || is_preproduction_preview
      ? false
      : content_html_preview?.includes("table-container")

  const create_notice_pdf = (e) => {
    e.preventDefault()
    window.print()
  }

  return (
    <div className="columns mt-4 is-flex-direction-column-print">
      <p className="is-print-only mx-3 help">
        Abruf der Vergabeunterlagen unter:{" "}
        <a href="https://bi-medien.de/text" className="link">
          bi-medien.de/text
        </a>
      </p>
      <div className="column is-3" id="noticepage-sidebar">
        <p
          className="title is-5 has-text-mitternachtsblau mb-0 is-hidden-print"
          style={{ paddingTop: "1.25rem" }}
        >
          Übersicht{" "}
          {!is_direct_invite &&
          has_parts &&
          picked_part !== "none" &&
          !!picked_part ? (
            <span className="has-text-mitternachtsblau-50">
              Los {picked_part?.Number}
            </span>
          ) : null}
        </p>
        <hr className="is-mitternachtsblau-30 mt-2 mb-5" />
        <div id="noticepage-metadata">
          {!!TenderTypeName && !RefIDStringBI.startsWith("B") ? (
            <div>
              <p className="title is-7 has-text-budgetierungshellblau mb-0">
                Verfahrensart
              </p>
              <p className="mb-5 has-text-mitternachtsblau">{TenderTypeName}</p>
            </div>
          ) : null}
          <div>
            {!!ZoneOfRequestName ? (
              <div>
                <p className="title is-7 has-text-budgetierungshellblau mb-0">
                  Art der Vergabe
                </p>
                <p className="mb-5 has-text-mitternachtsblau">
                  {ZoneOfRequestName}
                </p>
              </div>
            ) : null}
            {!!ServiceTypeName ? (
              <React.Fragment>
                <p className="title is-7 has-text-budgetierungshellblau mb-0">
                  Art der Leistung
                </p>
                <p className="mb-5 has-text-mitternachtsblau">
                  {ServiceTypeName}
                </p>
              </React.Fragment>
            ) : null}
          </div>

          {ZoneOfRequest !== 4 &&
          (!!ActBefore ||
            !!ValidUntil ||
            Math.min(
              !!picked_part?.SubmissionDate,
              !!picked_part?.ApplicationUntil
            )) ? (
            <div>
              <p className="title is-7 has-text-budgetierungshellblau mb-0">
                Frist
              </p>
              {!already_expired ? (
                <p className="mb-5 has-text-mitternachtsblau">{display_date}</p>
              ) : (
                <p className="mb-5 has-text-danger is-line-through">
                  {display_date}
                </p>
              )}
            </div>
          ) : null}
          {!!CompletitionDeadline || !!picked_part?.CompletitionDeadline ? (
            <div>
              <p className="title is-7 has-text-budgetierungshellblau mb-0">
                Zeitraum der Ausführung
              </p>
              <p className="mb-5 has-text-mitternachtsblau">
                {picked_part?.CompletitionDeadline || CompletitionDeadline}
              </p>
            </div>
          ) : null}
          {!is_preproduction_preview ? (
            <div>
              <p className="title is-7 has-text-budgetierungshellblau mb-0">
                Auftraggeber
              </p>
              <div className={`mb-5`}>
                {!!bi_platform || is_magic_word_invite ? (
                  <p className="has-text-mitternachtsblau">{buyer_string}</p>
                ) : (
                  <a
                    className="is-flex mt-3 is-clickable link"
                    href=" #"
                    onClick={toggle_register_app_modal}
                  >
                    <PadlockIcon {...{ className: "my-auto" }} />
                    <span className="ml-2">Jetzt freischalten</span>
                  </a>
                )}
              </div>
            </div>
          ) : null}
          {places_of_delivery_struct?.[0] ? (
            <div>
              <p className="title is-7 has-text-budgetierungshellblau mb-0">
                Ausführungsort
                {places_of_delivery_struct.length > 1 ? "e" : ""}
              </p>

              <PlacesOfDeliveryList
                {...{
                  places_of_delivery_struct,
                  text_color: "mitternachtsblau",
                }}
              />
            </div>
          ) : null}
          {!!linked_landingpages?.[0] ? (
            <div className="is-hidden-print">
              <p className="title is-5 has-text-mitternachtsblau mb-0 pt-6">
                Zugehörige Leistungen
              </p>
              <hr className="is-mitternachtsblau-30 mt-2 mb-5" />
              <div className="buttons mt-2">
                {linked_landingpages?.map(
                  ({ landingpage_link, short_name }, index) => (
                    <Link
                      to={landingpage_link}
                      key={`${landingpage_link}-${index}`}
                      className="button is-small is-rounded is-mitternachtsblau is-outlined"
                    >
                      {short_name}
                    </Link>
                  )
                )}
              </div>
            </div>
          ) : null}
          {!!places_of_delivery_struct?.[0]?.State && !!ServiceTypeName ? (
            <div className="is-hidden-print">
              <div className="my-5">
                <a
                  href={`/ausschreibungsdienste#demosearch-box&bundesland=${places_of_delivery_struct[0].State}&category=${ServiceTypeName}en`}
                  style={{ minWidth: 185 }}
                  className="link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ähnliche {ZoneOfRequest === 4 ? "Aufträge" : "Vergaben"}
                </a>
              </div>
            </div>
          ) : null}
          {paywall_preview_type === "blurred" ? (
            <NoticepagePaywallHalfpage {...{ ZoneOfRequest }} />
          ) : null}
        </div>
      </div>
      <div className="column">
        {paywall_preview_type === "unavailable" ? (
          <PaywallIllustrationDesk {...{ ZoneOfRequest }} />
        ) : null}

        {paywall_preview_type !== "unavailable" ? (
          <div className="box mb-5">
            {is_magic_word_invite || bi_platform ? (
              <a
                href=" #"
                onClick={create_notice_pdf}
                className="is-pulled-right is-hidden-print"
                aria-label="drucken"
              >
                <PrinterIcon />
              </a>
            ) : null}
            {(!!ScopeOfServices || !!picked_part?.ScopeOfServices) &&
            (!!ScopeOfServices?.replace(/[LloOsS\d\s:.,]+/g, "") ||
              picked_part?.ScopeOfServices?.replace(
                /[LloOsS\d\s:.,]+/g,
                ""
              )) ? (
              <React.Fragment>
                <p className="title has-text-mitternachtsblau is-3 mt-2 is-3 is-size-4-mobile">
                  Leistungsbeschreibung
                </p>
                <div className="box is-bordered is-shadowless">
                  <div
                    style={{ overflowWrap: "break-word" }}
                    className="content has-text-mitternachtsblau"
                    dangerouslySetInnerHTML={{
                      __html: picked_part?.ScopeOfServices || ScopeOfServices,
                    }}
                  ></div>
                </div>
              </React.Fragment>
            ) : null}
            {is_preproduction_preview ? (
              <React.Fragment>
                <div className="box is-bordered is-shadowless">
                  <div className="section">
                    <p className="title has-text-mitternachtsblau is-4 has-text-centered mb-2">
                      Vorschau zur Vergabe {RefIDStringBI}
                    </p>
                    <p className="has-text-mitternachtsblau mx-6">
                      Die Vergabe wurde durch den Auftraggeber vorbereitet, aber
                      leider ist die Bekanntmachung noch nicht verfügbar. Sobald
                      die Bekanntmachung zur Vergabe verfügbar ist, wird Sie
                      hier erscheinen.
                    </p>
                    <p className="has-text-mitternachtsblau mx-6 my-4">
                      Trotzdem können Sie bereits Unterlagen, Mitteilungen sowie
                      die Teilnahme- und Angebotskonditionen zur Vergabe
                      einsehen.
                    </p>
                  </div>
                </div>
              </React.Fragment>
            ) : is_direct_invite ? (
              <React.Fragment>
                <p className="title has-text-mitternachtsblau is-3 mt-2">
                  Sie wurden eingeladen!
                </p>
                <div className="box is-bordered is-shadowless">
                  <div className="section">
                    <p className="title has-text-mitternachtsblau is-4 has-text-centered mb-2">
                      Möchten Sie am Verfahren teilnehmen?
                    </p>
                    <p className="has-text-mitternachtsblau has-text-centered">
                      Sie wurden zur Abgabe eines Angebots aufgefordert vom
                      Auftraggeber:
                    </p>
                    <div
                      className="box has-background-mitternachtsblau-10 mx-auto is-shadowless my-6"
                      style={{ maxWidth: 327 }}
                    >
                      <p className="has-text-mitternachtsblau has-text-weight-bold mb-2">
                        {buyer_string}
                      </p>
                      <p className="has-text-mitternachtsblau">
                        {awarding_authority_address?.zipcode}{" "}
                        {awarding_authority_address?.city}
                      </p>
                    </div>
                    <p className="has-text-mitternachtsblau has-text-centered mb-6">
                      Über die Reiter{" "}
                      <a href="# " onClick={unterlagen_click}>
                        Unterlagen
                      </a>
                      ,{" "}
                      <a href="# " onClick={mitteilungen_click}>
                        Mitteilungen
                      </a>{" "}
                      und{" "}
                      <a href="# " onClick={teilnahme_click}>
                        Teilnahme & Angebote
                      </a>
                      <br />
                      können Sie Details zum Verfahren auch ohne Login einsehen.
                    </p>
                    <div className="buttons is-centered">
                      <button
                        onClick={open_accept_invite_modal}
                        style={{ minWidth: 185 }}
                        className="button is-mitternachtsblau is-outlined has-text-weight-bold mx-3"
                      >
                        Ablehnen
                      </button>
                      <button
                        onClick={open_accept_invite_modal}
                        style={{ minWidth: 185 }}
                        className="button is-sonnengelb has-text-weight-bold mx-3"
                      >
                        Annehmen
                      </button>
                    </div>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <p className="title has-text-mitternachtsblau  is-3 is-size-4-mobile mt-2">
                  Bekanntmachungstext
                </p>
                <div className="box is-bordered is-shadowless">
                  <div
                    style={{
                      display: "grid",
                      overflow: has_table ? "auto" : "",
                    }}
                  >
                    <div
                      style={{
                        overflowWrap: "break-word",
                        wordBreak: "break-word",
                        maxWidth: 944,
                        position: "relative",
                        gridArea: "1/1",
                      }}
                      className={`content noticepage-content`}
                      dangerouslySetInnerHTML={{
                        __html: content_html_preview,
                      }}
                    ></div>
                    {paywall_preview_type === "blurred" ? (
                      <div
                        style={{
                          marginTop: "auto",
                          height: 150,
                          position: "relative",
                          gridArea: "1/1",
                          boxShadow:
                            "rgb(255 255 255) 0px -200px 60px -80px inset",
                        }}
                      ></div>
                    ) : null}
                  </div>
                  {paywall_preview_type === "blurred" ? (
                    <NoticepagePaywallSticker {...{ show_video }} />
                  ) : null}
                </div>
              </React.Fragment>
            )}
          </div>
        ) : null}
      </div>
    </div>
  )
}
